import style from "./Container.module.css";

function Container(props) {
    return (
        <div className={style.container}
            style={
                {
                    width: (props.width ? props.width : null),
                    maxWidth: (props.maxWidth ? props.maxWidth : null),
                    height: (props.height ? props.height : null),
                    backgroundColor: (props.backgroundColor ? props.backgroundColor : null),
                    border: (props.border ? props.border : null),
                    padding: (props.padding ? props.padding : null),
                    boxShadow: (props.boxShadow ? props.boxShadow : null),
                    borderBottom: (props.borderBottom ? props.borderBottom : null),
                    
                    /* 이건정 추가 속성 */
                    margin: (props.margin ? props.margin : null),
                    overflowX: (props.overflowX ? props.overflowX : null),
                    overflowY: (props.overflowY ? props.overflowY : null),
                    scrollbarWidth: (props.scrollbarWidth ? props.scrollbarWidth : null),
                    display: (props.display ? props.display : null),
                    justifyContent: (props.justifyContent ? props.justifyContent : null),
                    alignItems: (props.alignItems ? props.alignItems : props.flexStart ? "flex-start" : "center"),
                }
            }>
            {props.children}
        </div>
    );
}

export default Container;